import React, { useState } from "react";
import { Grid, Menu } from "semantic-ui-react";
import { useSelector } from "react-redux";

import TopNav from "../../common/containers/top-nav";
import { CustomerContainerBalance } from "../containers/balance";
import { generateBalancePdf } from "../services/helpers";

const CustomerPageBalance = ({ computedMatch }) => {
    const customerId = parseInt(computedMatch.params.customerId);
    const customer = useSelector(({ customerList }) => {
        return customerList.data.find(c => c.id === customerId);
    });
    const [generatingPdfUrl, setGeneratingPdfUrl] = useState(false);
    const handlePdfGeneration = ({ onSuccess }) => {
        generateBalancePdf(customerId, setGeneratingPdfUrl).then(pdfUrl => {
            if (onSuccess) {
                onSuccess(pdfUrl);
            }
        });
    };

    return (
        <Grid>
            <TopNav
                headerIcon="dollar sign"
                subheader={customer?.name || "Loading customer..."}
                headerContent="Customer Balance"
                extraButtons={() => (
                    <Menu.Item
                        name="Pdf"
                        onClick={handlePdfGeneration}
                        disabled={!customer || generatingPdfUrl}
                        icon={{
                            name: generatingPdfUrl ? "spinner" : "file",
                            loading: generatingPdfUrl,
                        }}
                    />
                )}
            />
            <Grid.Row>
                <Grid.Column width={16}>
                    <CustomerContainerBalance customerId={customerId} />
                </Grid.Column>
            </Grid.Row>
        </Grid>
    );
};

export default CustomerPageBalance;
